import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";
import { studio, artists } from "../../mock";

const stats = [
  { value: String(artists.length), label: "Resident Artists" },
  { value: "7", label: "Days a Week" },
  { value: "12–8", label: "Open Daily" },
];

const IntroSection = () => {
  return (
    <section className="relative overflow-hidden py-24 lg:py-32" id="about" data-testid="intro-section">
      <div className="container-x grid gap-16 lg:grid-cols-12 lg:gap-12">
        {/* Image */}
        <Reveal className="relative lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden bg-card">
            <img
              src={studio.images.heroPortrait}
              alt="Inside Avalon Tattoo Collective"
              loading="lazy"
              className="h-full w-full object-cover grayscale"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-4 hidden border border-border bg-background px-6 py-5 sm:block lg:-right-8">
            <p className="display text-5xl text-primary">Est.</p>
            <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-muted-foreground">New Westminster</p>
          </div>
        </Reveal>

        {/* Copy */}
        <div className="flex flex-col justify-center lg:col-span-7 lg:pl-8">
          <Reveal>
            <p className="eyebrow">{studio.welcomeTitle}</p>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="display mt-6 text-[clamp(3rem,6.5vw,6.5rem)] uppercase leading-[0.88] tracking-wide">
              Every artist has <br className="hidden md:block" />
              <span className="font-serif italic normal-case tracking-normal text-foreground/90">their own vision.</span>
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
              {studio.welcomeBody}
            </p>
          </Reveal>

          <Reveal delay={240}>
            <div className="mt-12 grid grid-cols-3 divide-x divide-border border-y border-border">
              {stats.map((s) => (
                <div key={s.label} className="px-4 py-6 first:pl-0 sm:px-8">
                  <p className="display text-5xl leading-none md:text-6xl">{s.value}</p>
                  <p className="mt-2 text-[10px] font-semibold uppercase tracking-[0.24em] text-muted-foreground">{s.label}</p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={320}>
            <Link
              to="/guest-spots"
              className="mt-10 inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.24em] text-primary transition-colors hover:text-foreground"
              data-testid="intro-guest-link"
            >
              Guest spots available here
              <span className="flex h-9 w-9 items-center justify-center border border-primary/40 transition-colors group-hover:border-foreground">
                <ArrowUpRight className="h-4 w-4" />
              </span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
